import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Header from "../components/Header"
import TestsHero from "../components/local/MentalTests/Hero"
import FAQs from "../components/local/MentalTests/FAQs"
import Blog from "../components/local/Blog/Blog"
import CTA from "../components/local/MentalTests/CTA"
import Footer from "../components/local/Footer"
import styles from "./index.module.scss"
import { getBlogPosts, getBlogPost } from "../utils/blog"
import { goToStressTestPSS } from "../utils/browser"

export async function getStaticProps({ locale, locales }) {
  const { posts, postsUnordered } = await getBlogPosts({
    locale,
    params: "?tags=33",
  })

  const language = locale.split("-")[0] || "en"

  const postIds = {
    en: 189,
    de: 191,
    es: 193,
    fr: 195,
    it: 197,
    pt: 199,
  }

  const postId = postIds[language] || 189

  const { content: { rendered: post = "" } = {} } = await getBlogPost({
    postId,
  })

  return {
    props: {
      ...(await serverSideTranslations(locale.substring(0, 2), [
        "tests",
        "common",
      ])),
      post,
      posts,
      locales,
      postsUnordered,
    },
  }
}

function FreeDepressionTestPage({ locales, post, ...props }) {
  const { t } = useTranslation("tests")

  const buttonProps = {
    buttonText: t("TESTS_DEPRESSION_PHQ9_BUTTON", { ns: "tests" }),
    buttonAction: goToStressTestPSS,
  }

  return (
    <div className={styles.MainWrapper}>
      <Header
        logoUrl="/assets/logo-black.png"
        pageTitle={t("TESTS_DEPRESSION_PHQ9_TITLE")}
        pageDescription={t("TESTS_DEPRESSION_PHQ9_META")}
        fixedHeader={false}
        transparent={true}
        displayProductHunt={true}
      />
      <TestsHero
        h1Description={t("TESTS_HERO_DESCRIPTION_TEXT")}
        h1Content={t("TESTS_HERO_MAIN_TEXT")}
        subTitle={t("TESTS_HERO_SUBTITLE")}
        imageAlt={t("TESTS_DEPRESSION_PHQ9_TITLE")}
        imageUrl="depression-test-free"
        {...buttonProps}
      />
      <FAQs post={post} />
      <CTA {...buttonProps} />
      <Blog posts={props.posts} />

      <Footer />
    </div>
  )
}

export default FreeDepressionTestPage
